<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 class="fronttitle paired">Contents</h1>
<hr/>
<p class="toc sub"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></p>
<p class="toc sub"><a href="#/contents">Contents</a></p>
<p class="toc sub"><a href="#/front01">Copyright</a></p>
<p class="toc"><a href="#/c01">How the World Was Saved</a></p>
<p class="toc"><a href="#/c02">Trurl’s Machine</a></p>
<p class="toc"><a href="#/c03">A Good Shellacking</a></p>
<p class="part"><a href="#/c001">The Seven Sallies of Trurl AND Klapaucius</a></p>
<p class="toc"><a href="#/c04">The First Sally or the Trap of Gargantius</a></p>
<p class="toc"><span href="#/c05" title="Link target outside of Sample">The First Sally (A) or Trurl’s Electronic Bard</span></p>
<p class="toc"><span href="#/c06" title="Link target outside of Sample">The Second Sally or the Offer of King Krool</span></p>
<p class="toc"><span href="#/c07" title="Link target outside of Sample">The Third Sally or the Dragons of Probability</span></p>
<p class="toc"><span href="#/c08" title="Link target outside of Sample">The Fourth Sally, or How Trurl Built a Femfatalatron to Save Prince Pantagoon from the Pangs of Love, and How Later He Resorted to a Cannonade of Babies</span></p>
<p class="toc"><span href="#/c09" title="Link target outside of Sample">The Fifth Sally or the Mischief of King Balerion</span></p>
<p class="toc"><span href="#/c10" title="Link target outside of Sample">The Fifth Sally (A) or Trurl’s Prescription</span></p>
<p class="toc"><span href="#/c11" title="Link target outside of Sample">The Sixth Sally or How Trurl and Klapaucius Created a Demon of the Second Kind to Defeat the Pirate Pugg</span></p>
<p class="toc"><span href="#/c12" title="Link target outside of Sample">The Seventh Sally or How Trurl’s Own Perfection Led to No Good</span></p>
<p class="toc"><span href="#/c13" title="Link target outside of Sample">Tale of the Three Storytelling Machines of King Genius</span></p>
<p class="toc"><span href="#/c14" title="Link target outside of Sample">Altruizine, or a True Account of How Bonhomius the Hermetic Hermit Tried to Bring About Universal Happiness, and What Came of It</span></p>
<p class="part"><span href="#/c002" title="Link target outside of Sample">From the Cyphroeroticon, or Tales of Deviations Superfixations and Aberrations of the Heart</span></p>
<p class="toc"><span href="#/c15" title="Link target outside of Sample">Prince Ferrix and the Princess Crystal</span></p>
<p class="toc sub"><span href="#/back01" title="Link target outside of Sample">About the Author</span></p>
<p class="toc sub"><span href="#/back02" title="Link target outside of Sample">Connect with HMH</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?17936418